import React from 'react'
import { Page } from '../../components'
import { 
    CellsTitle, Cells, Cell, CellBody, CellFooter, Toast, Dialog, Form, FormCell,
    Radio, Input, Button
} from 'react-weui'
import { browserHistory } from 'react-router'
import {
    shareMusic,
    sharePic,
    wxPay,
    shareUrl,
    upload,
} from '../../utils/connectApp'
import '../../css/page/ConnectAppPage.css'


class ConnectAppPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            cover: '',
            file: '',
            isPending: false,
            selectData: [
                { id: 1, name: 'name1' },
                { id: 2, name: 'name2' },
                { id: 3, name: 'name3' },
                { id: 4, name: 'name4' },
            ],
            selectedId: 3,
            inputUrl: 'http://dbg.weike.fm:1438',
        }
    }
    componentDidMount () {
        document.title = 'APP联调demo'
    }
    render() {
        return (
            <Page>
                <div className="wk-inner-page connect-app-page">
                    <CellsTitle>输入网址跳转</CellsTitle>
                    <Cells>
                        <Cell>
                            <CellBody>
                                <Input 
                                    value={this.state.inputUrl}
                                    onChange={e => this.setState({ inputUrl: e.target.value })}
                                />
                            </CellBody>
                            <CellFooter>
                                <Button size='small' onClick={e => location.assign(this.state.inputUrl)}>跳转</Button>
                                <Button size='small' onClick={e => location.assign(this.state.inputUrl)}>pushState</Button>
                            </CellFooter>
                        </Cell>
                    </Cells>

                    <CellsTitle>QQ支付宝内打开应用</CellsTitle>
                    <Cells>
                        <Cell onClick={() => location.assign('lizhiweike://')} href="javascript:;">
                            <CellBody>
                                点我打开荔枝微课APP
                            </CellBody>
                        </Cell>
                    </Cells>

                    <CellsTitle>分享</CellsTitle>
                    <Cells>
                        <Cell onClick={() => shareMusic({
                            title: '我是标题',
                            desc: '我是文本',
                            shareUrl: 'https://y.qq.com/n/yqq/song/107192078_num.html?ADTAG=h5_playsong&no_redirect=1',
                            icon: 'https://staticqc.weike.fm/favicon.ico',
                            musicUrl: 'http://cdn.imbgf.com/test-music.mp3',
                        })} href="javascript:;">
                            <CellBody>
                                分享音乐
                            </CellBody>
                        </Cell>
                        <Cell onClick={() => sharePic({
                            pic: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1505992988300&di=b1e6439fa29ae1f98fbe4a8a9477f7d7&imgtype=0&src=http%3A%2F%2Fs9.rr.itc.cn%2Fg%2Fm%2Fe7%2F7vumyMv.jpg'
                        })} href="javascript:;">
                            <CellBody>
                                分享图片
                            </CellBody>
                        </Cell>
                        <Cell onClick={() => shareUrl({
                            title: '我是分享链接', desc: '我是分享文本', url: 'http://www.imbgf.com', icon: 'https://staticqc.weike.fm/favicon.ico'
                        })} href="javascript:;">
                            <CellBody>
                                分享链接
                            </CellBody>
                        </Cell>
                    </Cells>

                    <CellsTitle>支付</CellsTitle>
                    <Cells>
                        <Cell onClick={() => wxPay({
                            lectureId: '4845962',
                            product: 'pay_lecture',
                            type: 'type2333',
                        })} href="javascript:;">
                            <CellBody>
                                支付一个课程
                            </CellBody>
                        </Cell>
                    </Cells>

                    <CellsTitle>上传测试</CellsTitle>
                    <Cells>
                        <Cell href="javascript:;">
                            <CellBody>
                                点我预览并上传图片
                                <input type="file" onChange={e => upload(this, e)} accept="image/gif,image/jpeg,image/jpg,image/png,image/bmp" />
                            </CellBody>
                        </Cell>
                        <img src={this.state.cover} />
                    </Cells>

                    <CellsTitle>原生select测试</CellsTitle>
                    <Cells>
                        <Cell href="javascript:;">
                            <CellBody>
                                <select>
                                    {
                                        this.state.selectData.map(item => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </select>
                            </CellBody>
                        </Cell>
                    </Cells>
                    <CellsTitle>模拟select测试</CellsTitle>
                    <Cells>
                        <Cell>
                            <CellBody>
                                <select id="" onClick={e => this.setState({ isShowSelectDialog: true })}>
                                    {
                                        this.state.selectData.map(item => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </select>
                                <Dialog className='wk-select-dialog' type="ios" title='' buttons={[
                                    {label: '取消', onClick: e => this.setState({ isShowSelectDialog: false })}
                                ]} show={this.state.isShowSelectDialog}>
                                    <Form radio className='text-left'>
                                        {
                                            this.state.selectData.map(item => (
                                                <FormCell key={item.id} radio>
                                                    <CellBody>{item.name}</CellBody>
                                                    <CellFooter>
                                                        <Radio 
                                                            value={item.id} 
                                                            checked={item.id === this.state.selectedId} 
                                                            onChange={e => this.setState({ selectedId: item.id })}
                                                        />
                                                    </CellFooter>
                                                </FormCell>
                                            ))
                                        }
                                    </Form>
                                </Dialog>
                            </CellBody>
                        </Cell>
                    </Cells>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
            </Page>
        )
    }
}

export default ConnectAppPage


// WEBPACK FOOTER //
// ./src/pages/connectApp/ConnectAppPage.js